import React, { useEffect, useRef, useState } from 'react';
import './Similar_products.css'
import Common_Title_1 from '../../common/common_components/common_title_1/Common_Title_1'
import './Similar_products.css'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Autoplay, Pagination } from 'swiper/modules';
import Similar_product_card from '../../common/common_components/similar-product-card/Similar_product_card';
import { useDispatch, useSelector } from 'react-redux';
import { GetAllProducts } from '../../../features/admin/products/slice';
import { IDS } from '../../../utils/IDS';
import { encodeId } from '../../../utils/common';


const Similar_products = ({ catId, prodId }) => {


    const dispatch = useDispatch();
    const products = useSelector((state) => state.commerce.products);




    useEffect(() => {
        let params = {};
        if (catId) {
            params.p_category_id = catId;
            params.product_id = prodId;
        }
        dispatch(GetAllProducts(params));

    }, [dispatch, catId]);

    return (
        <>
            <section className='Similar_products_sec'>
                <div className='container p-0'>
                    <Common_Title_1 subText={'Similar Products'} linktext={'See all'} link={'/all-products'} />

                    <div className='slidersec'>
                        <Swiper
                            autoplay={{
                                delay: 2000,
                                disableOnInteraction: false,
                            }}
                            modules={[Autoplay]}
                            breakpoints={{
                                0: {
                                    slidesPerView: 2,
                                    spaceBetween: 5,
                                },
                                400: {
                                    slidesPerView: 3,
                                    spaceBetween: 5,
                                },
                                575: {
                                    slidesPerView: 4,
                                    spaceBetween: 10,
                                },
                                768: {
                                    slidesPerView: 5,
                                    spaceBetween: 10,
                                },
                                991: {
                                    slidesPerView: 7,
                                    spaceBetween: 10,
                                },
                                1200: {
                                    slidesPerView: 8,
                                    spaceBetween: 10,
                                },
                            }}
                            className="mySwiper">
                            {products?.data?.map((data, index) => (
                                <SwiperSlide>
                                    <Similar_product_card
                                        image={IDS.IMG_URL + data.image}
                                        name={data.name}
                                        subname={data.p_category?.name}
                                        oldprise={data.mrp}
                                        prise={data.price}
                                        link={`/product-details/${encodeId(data?.id)}`}
                                    />
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Similar_products